/**
 * Logomarca FIRST2JOB — PNG original com fundo transparente.
 *
 * Ficheiro: /logo-transparent.png  (RGBA, 1458×415 px, fundo transparente)
 *
 * Props:
 *   size     — "xs" | "sm" | "md" | "lg" | "xl"
 *   variant  — "dark"  → fundo claro  (logo em cores originais)
 *              "light" → fundo escuro (logo a branco via CSS filter)
 *   className
 *   withMark / tagline — aceites por compatibilidade, ignorados
 *                        (tagline já faz parte da imagem)
 */

const HEIGHTS = { xs: 28, sm: 44, md: 52, lg: 68, xl: 88 };

export const Logo = ({
  size = "md",
  variant = "dark",
  className = "",
  /* compat — ignored */
  withMark,
  tagline,
}) => {
  const h = HEIGHTS[size] || HEIGHTS.md;

  return (
    <img
      src="/logo-transparent.png"
      alt="FIRST2JOB — Encontre. Conecte. Evolua."
      height={h}
      draggable={false}
      style={{
        height: h,
        width: "auto",
        display: "block",
        /* Em fundos escuros: converte para branco total mantendo forma */
        filter: variant === "light" ? "brightness(0) invert(1)" : "none",
      }}
      className={className}
    />
  );
};

/**
 * Apenas o ícone circular (compatibilidade com código legado).
 */
export const LogoMark = ({ size = 34, className = "", light = false }) => (
  <img
    src="/logo-transparent.png"
    alt="FIRST2JOB"
    height={size}
    draggable={false}
    style={{
      height: size,
      width: "auto",
      display: "block",
      filter: light ? "brightness(0) invert(1)" : "none",
    }}
    className={className}
  />
);
